import { Link as BaseLink } from '@lokalise/louis';

import styled from '@app/styled';
import { color } from '@app/theme';

export const Description = styled.div``;

export const Link = styled(BaseLink)`
    color: ${color('custom.neutral1')};
    text-decoration: underline;
`;
